export default function SubAccountsErrorState() {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">
      <h4 className="tw-mb-2">Error loading sub-accounts</h4>
      <p className="tw-text-neutral-500">
        This could be due to a network issue or a temporary problem on our end.
      </p>
    </div>
  );
}
